// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import KwPanel from '../../common/KwPanel';

import { toast } from 'react-toastify';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';
import { deleteAllSKUPrices } from '../../../api/skuPriceApi';

function DeleteAllDrafts({ done, cancel }) {
  const { t } = useTranslation();
  const handleDelete = () => {
    deleteAllSKUPrices()
      .then(() => {
        toast.success(t('Draft prices successfully deleted'));
        done();
      })
      .catch((e) => {
        console.error(e);
        toast.error(t('Failed to delete draft prices'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <p>{t('This will delete all un-published draft prices')}</p>
        <Button
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the draft prices')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}


function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAllDrafts);
